import styled from 'styled-components'
import { ImgComponent, ButtonComponent } from 'Pages/landings/newLandings/common/components'
import {
	themeObject,
	textModels,
	Breakpoints,
	media,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: grid;
	grid: repeat(2, auto) / 1fr;
	row-gap: 24px;
	margin: 0px 8px;
	${media('margin: 0px 93px;', Breakpoints.ms)}
	${media('grid: 1fr / repeat(2, 1fr); column-gap: 32px; margin: 0px 72px;', Breakpoints.lx)}
${media('margin: 0px 179px;', Breakpoints.xl)}
`

export const CardWrapper = styled.div`
	${media('max-width: 488px;', Breakpoints.xl)}
	display: flex;
	flex-direction: column;
	padding: 16px;
	border-radius: 16px;
	background: ${themeObject.colors.grey[50]};
	box-sizing: border-box;
	${media('padding: 32px;', Breakpoints.ms)}
`

export const ImgWrapper = styled(ImgComponent)`
	position: relative;
	height: 200px;
	margin-bottom: 24px;
`

export const Img = styled.img`
	object-fit: cover;
	width: 100%;
	height: 100%;
	border-radius: 16px;
`

export const Title = styled.p`
	color: ${themeObject.colors.grey[800]};
	${textModels('notAdaptive', 'h2')}
	text-align: center;
	margin-bottom: 8px;
`

export const SubTitle = styled.p`
	color: ${themeObject.colors.grey[600]};
	${textModels('notAdaptive', 'm')}
	text-align: center;
	margin-bottom: 24px;
`

export const Button = styled(ButtonComponent)`
	width: 100%;
	${media('margin-top: auto;', Breakpoints.lx)}
`

export const Ad = styled.div`
	box-sizing: border-box;
	width: 73px;
	height: 24px;
	border-radius: 12px;
	padding: 4px 8px;
	text-transform: uppercase;
	color: ${themeObject.colors.grey[500]};
	${textModels('notAdaptive', 'xs')}
	background-color: rgba(255, 255, 255, 0.8);
`
export const AdWrapper = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
`
